import {initDetailByAPI} from '@web/actions/detail'
import makeSlice from '@web/slices/rewardPoint/sliceMaker'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initDetailByAPI.fulfilled, (state, {payload}) => {
            const {pay} = payload.data
            /** 적립포인트 사용 금액 */
            state.amount = pay.rewardPointPayAmount
        })
    },
})

export default slice.reducer
